import { render, staticRenderFns } from "./DayMealItem.vue?vue&type=template&id=68c1d9c4&scoped=true&"
import script from "./DayMealItem.vue?vue&type=script&lang=js&"
export * from "./DayMealItem.vue?vue&type=script&lang=js&"
import style0 from "./DayMealItem.scss?vue&type=style&index=0&id=68c1d9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1d9c4",
  null
  
)

export default component.exports